import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import AppContext from '../context/HeaderContext';

const menu_css = {
	height : "100%",
	position : "fixed",
	marginTop : "0px",
	background: "#f2f3f3",
};

function AdminSideNav() {
	const { user } = useContext(AppContext);

	return (
		<Menu
			vertical
			style={menu_css}
		>
			<Menu.Item
				header
				name="Runs"
				as={NavLink}
				to="/runs"
			>Test Ledger</Menu.Item>

			<Menu.Item header>Admin</Menu.Item>
			<Menu.Item
				name="Users"
				as={NavLink}
				to="/admin/users">
			</Menu.Item>
			<Menu.Item
				as={NavLink}
				name="Projects"
				to="/admin/projects"
			/>
			<Menu.Item
				as={NavLink}
				name="Billing"
				to="/admin/billing"
			/>
			{/* <Menu.Item
				as={NavLink}
				name="Usage"
				to="/admin/usage"
			/> */}

			{!!user.super_user &&
				<Menu.Item
					as={NavLink}
					name="Organizations"
					to="/admin/organizations"
				/>
			}
		</Menu>
	);
}

export default AdminSideNav;
